<template>
	<div class="result">
		<div
			:style="`background-image: url(${image}); background-position: center; background-size: cover; height: 100%`"
		>
			<div class="result__overlay">
				<div class="result__overlay__outter-border">
					<div class="result__overlay__inner-border">
						<div class="result__logo-container">
							<img
								class="result__white-logo"
								:src="
									require('@/assets/images/LOGO-OUB-WHITE.svg')
								"
								alt="Officine Universelle Buly"
							/>
						</div>
						<span class="result__title">
							{{ $t('result.title') }}
						</span>
						<span v-if="concern" class="result__concern">
							{{ $t('result.concern') }}: {{ concern }}
						</span>
						<div class="result__cards-container">
							<div
								v-for="product in products"
								:key="product.id"
								:class="[
									'result__products-container',
									{
										'result__products-container__one-product':
											isOneProductOnly
									}
								]"
							>
								<v-product
									class="result__product"
									:price="product.price"
									:currencyCode="product.currencyCode"
									:title="product.title"
									:description="product.description || ''"
									:image="product.bulyImage || ''"
									:careTag="product.bulyCareTag"
									:isSelected="
										selected.includes(
											product.bulyShopifyProductId
										)
									"
									@select="
										onSelect(product.bulyShopifyProductId)
									"
								/>
							</div>
							<div
								v-if="tip"
								class="result__officine"
								:class="[
									'result__officine',
									{
										'result__officine__one-product':
											isOneProductOnly
									}
								]"
							>
								<span class="result__officine__title">
									{{ $t('result.tip') }}
								</span>
								<p class="result__officine__text">
									{{ tip.description }}
								</p>
							</div>
						</div>

						<div class="result__cta">
							<div class="result__cta__add-cart-container">
								<v-button
									:isResult="true"
									class="result__cta__button"
									:href="addCart"
								>
									{{ $t('result.addCart') }}
								</v-button>
							</div>
							<div class="result__cta__button-container">
								<folding-button />
								<v-button
									:isResult="true"
									class="result__cta__button"
									v-touch:tap="newSearch"
								>
									{{ $t('result.newSearch') }}
								</v-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div>
			<a class="result__link_cover" :href="$t('endPage.bulyUrl')">
				<v-cover
					v-if="$te('endPage.bulyImage.0')"
					class="result__cover"
					:image="$t('endPage.bulyImage.0.url')"
					:title="$t('result.endTitle')"
					:cta="$t('result.discover')"
					:dark="true"
				/>
			</a>
		</div>
	</div>
</template>

<style lang="sass">
.result
  margin: 0
  padding: 0

  &__overlay
    background-color: rgba(0, 0, 0, 0.6)
    top: 0
    left: 0
    width: 100%
    height: 100%
    position: relative
    z-index: 5
    &__outter-border
      margin: 0.3rem
      border: solid 1px white
    &__inner-border
      margin: 0.2rem
      border: solid 2px white
      display: flex
      flex-direction: column
      align-items: center

  &__logo-container
    display: flex
    flex-direction: column
    align-items: center
    margin-top: 1rem
    margin-bottom: 1rem

  &__white-logo
    color: white
    max-width: 35rem

  &__abstract
    background-color: var(--light-grey)
    padding:
      top: 30px
      bottom: 30px
    text-align: center
    line-height: 1.3

  &__title
    padding-top: 2rem
    display: inline-block
    font-style: normal
    font-weight: 500
    font-size: 6rem
    line-height: 1
    letter-spacing: 1.5px
    font-family: var(--font-family-title)
    text-align: center
    margin-bottom: 25px
    color: white
    text:
      align: center
      transform: uppercase
      decoration: none

  &__concern
    font-family: var(--font-family-label)
    font-size: var(--font-size-small)
    color: white
    line-height: 23px
    letter-spacing: 1px
    margin-top: 52px
    font-weight: var(--font-weight-light)
    margin-bottom: 25px

  &__cards-container
    padding: 0 1rem
    display: grid
    grid-template-columns: repeat(2, minmax(0, 1fr))
    gap: 2rem

  &__products-container
    display: flex
    justify-content: center

    &__one-product
      max-width: 100%

  &__product
    position: relative
    display: flex
    justify-content: center
    flex-direction: column
    align-items: center
    padding: 2rem 1rem
    max-width: 350px
    border: inset solid 1px white
    scroll-snap-align: start

  &__product::before
    position: absolute
    z-index: -1
    content: ''
    top: -5px
    left: -5px
    bottom: -5px
    right: -5px
    border: 1px white solid

  &__officine
    background-image: url(/img/illustrations/officine.jpg)
    background-size: cover
    background-position: center
    background-repeat: no-repeat
    box-sizing: border-box
    height: 500px
    min-height: 500px
    max-width: 385px
    height: auto
    padding:
      top: 64px
      bottom: 64px
      left: 35px
      right: 35px
    color: var(--white)
    text-align: center
    scroll-snap-align: start
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    &__one-product
      width: 100%

    &__title
      font-family: var(--font-family-label)
      font-size: var(--font-size-book)
      line-height: 35px

    &__text
      margin-top: 1.5rem
      font-style: normal
      font-weight: 400
      font-size: 25px
      line-height: 25px
      letter-spacing: 0.5px
      font-family: var(--font-family-text)
      font-size: var(--font-size-small)
      text-align: center

  &__cta
    padding: 4rem 0 2rem 0
    &__add-cart-container
      margin: 0 5rem 1rem 5rem
    &__button-container
      display: flex
      flex-direction: row
    &__button
      margin: 4px 20px 4px 20px
      &--unrolled
        .v-button__label
          background-color: var(--dark-green)
          color: var(--white)
        &::before
          border-color: var(--white)
        .result__cta__arrow
          transform: rotate(180deg)
    &__title
      width: 60%
    &__arrow
      transform: rotate(0deg)
      transition: transform 0.3s ease

  &__link_cover
    text-decoration: none

  @media screen and (max-width: 64em)
    &__white-logo
      max-width: 80%

    &__title
      font-size: var(--font-size-mobile-cover)
      line-height: 50px

    &__cards-container
      gap: 2rem
      display: grid
      grid-template-columns: repeat(1, minmax(0, 1fr))
      gap: 2rem

    &__product
      padding: 0.5rem 1rem

    &__officine
      margin-bottom: 1rem

    &__concern
      margin: 0 0 2rem 0
      font-size: 9px
      text-align: center

    &__cta
      margin-top: 16px
      padding: 0 0 2rem 0
      &__add-cart-container
        margin: 0
      &__button-container
        display: flex
        flex-direction: column-reverse

    &__cta__title
      width: 100%

  @media screen and (min-width: 80em)
    &__cards-container
        padding: 0 1rem
        display: grid
        grid-template-columns: repeat(3, minmax(0, 1fr))
        gap: 2rem

.picto_line
  display: flex
  flex-direction: row
  margin: auto
  &:not(:first-of-type)
    margin-top: 10px
  &__text, &__picto
    width: 33.3%
  &__picto
    text-align: left
  &__text
    margin-left: auto

  @media screen and (max-width: 64em)
    &__text
      width: 85%
    &__picto
      margin-left: 8px
      width: 12.5%
</style>

<script>
import VCover from '@/components/VCover'
import VButton from '@/components/VButton'
import VProduct from '@/components/VProduct'
import VSlider from '@/components/VSlider'
import api from '@/api'
import {
	fetchShopifyData,
	sendCRMEvent,
	STORAGE_ITEM_NAME,
	getCookie,
	COOKIE_KEY_EMAIL
} from '@/lib/utils'

import PopUp from '../components/Results/PopUp.vue'
import FoldingButton from '../components/Results/FoldingButton.vue'

// const ITEMS_PER_CATEGORY = {
// Cat_PlantOil: 2,
// Cat_Essential: 1,
// Cat_OralCare: 1,
// Cat_Curiosities: 1,
// Cat_Powder: 1,
// Cat_Clay: 1,
// Cat_BodyCare: 1,
// Cat_FaceCare: 1,
// Cat_Perfume: 1
// }

export default {
	name: 'Result',

	components: {
		VProduct,
		VButton,
		VCover,
		VSlider,
		PopUp,
		FoldingButton
	},

	data() {
		return {
			recommendPopupOpen: false,
			selected: [],
			image: '/img/portraits/portrait-result.jpg',
			products: []
		}
	},

	mounted() {
		this.fetchProducts()
	},

	computed: {
		concern() {
			const id = this.$store.state.answers.find(
				answer => answer.startsWith('N') || answer.startsWith('Q')
			)

			if (!id) {
				return
			}

			const concern = Object.values(this.$t(`answers.${id[0]}`)).find(
				answer => answer.bulyExternalid === id
			)

			return concern.title
		},

		tip() {
			return Object.values(this.$t('tips')).find(tip =>
				this.$store.state.answers.includes(tip.bulyExternalid)
			)
		},

		addCart() {
			return this.selected.reduce((previous, id, index) => {
				previous += id
				previous += index < this.selected.length - 1 ? ',' : ''
				return previous
			}, this.$t('store'))
		},

		isOneProductOnly() {
			return this.products?.length === 1
		}
	},

	methods: {
		async fetchProducts() {
			try {
				const filteredProductVariants = api.filter(
					this.$store.state.answers,
					Object.values(this.$t('products')),
					[
						'bulyGender',
						'bulyClimate1',
						'bulyClimate2',
						'bulyAge',
						'BulyBodyPart',
						'bulySkinType',
						'bulySkinProblemCategory'
					]
				)

				const variantIds = filteredProductVariants.map(
					product => product.bulyShopifyProductId
				)

				const queryProducts = `{
					products(query: "${variantIds.join(' OR ')}", first: 250) {
						edges {
							node {
								id
								title
								description
								onlineStoreUrl
								productCardShortDesc: metafield(namespace: "custom", key: "product_card_short_desc") {
									value
								}
								variants(first: 10) {
									edges {
										node {
											id
											quantityAvailable
											price {
												amount
												currencyCode
											}
											image {
												url(transform: {maxWidth: 500})
											}
										}
									}
								}
							}
						}
					}
				}`

				const { data: shopifyResponse } = await fetchShopifyData(
					queryProducts,
					api.lang === 'jp'
				)

				const shopifyProductVariants =
					shopifyResponse.products.edges.flatMap(edge =>
						edge.node.variants.edges.map(variant => ({
							...variant.node,
							productGid: edge.node.id,
							productTitle: edge.node.title,
							productDescription: edge.node.description,
							productUrl: edge.node.onlineStoreUrl,
							productCardShortDesc:
								edge.node.productCardShortDesc?.value
						}))
					)

				const shopifyVariantsMap = shopifyProductVariants.reduce(
					(map, variant) => {
						map[variant.id] = variant
						return map
					},
					{}
				)

				const finalProducts = filteredProductVariants
					.map(filteredVariant => {
						const shopifyVariant =
							shopifyVariantsMap[
								`gid://shopify/ProductVariant/${filteredVariant.bulyShopifyProductId}`
							] || null

						if (!shopifyVariant?.quantityAvailable) return null

						let currencyCode = shopifyVariant.price.currencyCode
						if (currencyCode === 'EUR') {
							currencyCode = '€'
						} else if (currencyCode === 'JPY') {
							currencyCode = '¥'
						}

						return {
							...filteredVariant,
							productGid: shopifyVariant.productGid,
							variantImage: shopifyVariant.image?.url,
							price: shopifyVariant?.price?.amount,
							currencyCode: currencyCode,
							productUrl: shopifyVariant.productUrl,
							productTitle: shopifyVariant.productTitle,
							productDescription:
								shopifyVariant.productDescription,
							productCardShortDesc:
								shopifyVariant.productCardShortDesc
						}
					})
					.filter(Boolean)

				// Send if email has been provided on the mail form screen
				// or if it has been provided in the cookie
				const email =
					sessionStorage.getItem(STORAGE_ITEM_NAME) ||
					getCookie(COOKIE_KEY_EMAIL)

				const id = this.$store.state.answers.find(
					answer => answer.startsWith('N') || answer.startsWith('Q')
				)

				const skinConcern = Object.values(
					this.$t(`answers.${id[0]}`)
				).find(answer => answer.bulyExternalid === id)?.title

				if (email) {
					// Prepare data for CRM
					const productsCRM = finalProducts.map(product => {
						return {
							img: product.variantImage || '',
							title: product.productTitle,
							priceAmount: product.price,
							priceCurrency: product.currencyCode,
							description: product.productDescription,
							shortDesc: product.productCardShortDesc,
							id: product.productGid.split('/').pop(),
							url: product.productUrl
						}
					})

					if (productsCRM?.length && !!skinConcern) {
						sendCRMEvent(email, skinConcern, productsCRM, api.lang)
					}
				}

				this.products = finalProducts

				this.$ga.send(
					this.$constants.ANALYTICS_EVENTS.PRODUCT_FINDER_RESULT,
					{
						product_finder_name: skinConcern
					}
				)
			} catch (error) {
				this.$ga.send(
					this.$constants.ANALYTICS_EVENTS.PRODUCT_FINDER_ERROR,
					{
						product_finder_name:
							this.$constants.PRODUCT_FINDER_NAME,
						error_type: 'fetch_products'
					}
				)
				console.error('Failed to fetch products:', error)
				return api.filter(
					this.$store.state.answers,
					Object.values(this.$t('products')),
					[
						'bulyGender',
						'bulyClimate1',
						'bulyClimate2',
						'bulyAge',
						'BulyBodyPart',
						'bulySkinType',
						'bulySkinProblemCategory'
					]
				)
			}
		},

		onSelect(id) {
			const index = this.selected.indexOf(id)
			if (index === -1) {
				this.selected.push(id)
			} else {
				this.selected.splice(index, 1)
			}
		},

		newSearch() {
			this.$store.commit('reinitAnswers')
			this.$ga.send('skin_concierge', {
				skin_concierge_action: 'restart'
			})
			this.$router.push('start')
		}
	}
}
</script>
